import api from 'api';

export const loadApplications = api('GET /api/promocodes/fields/applications');
export const loadCampaigns = api('POST /api/promocodes/fields/campaigns');
export const loadTypes = api('GET /api/promocodes/fields/types');
export const loadRewards = api('GET /api/promocodes/fields/rewards');
export const loadAffiliate = api('GET /api/promocodes/fields/affiliates');
export const loadPlatforms = api('GET /api/promocodes/fields/platforms');
export const loadUsers = api('GET /api/promocodes/promocode/users');
export const loadCountries = api('POST /api/promocodes/fields/countries');
export const loadConditions = api('GET /api/promocodes/fields/conditions');
export const loadCompensations = api(
  'GET /api/promocodes/fields/compensations'
);
